export const INTERACTIVE_LOGIN_COMPLETE = 'ogp:interactive-login-complete';

export function dispatchInteractiveLoginComplete() {
  window.dispatchEvent(new CustomEvent(INTERACTIVE_LOGIN_COMPLETE));
}
